module.exports = __webpack_public_path__ + "img/costSaving.fcf7ac60.png";